import { useEffect, useState } from 'react';
import api from '../api/axios';

/**
 * Counts shown as badges against features that have work waiting.
 *
 * Shared by the admin sidebar and the dashboard so a count means the same
 * thing in both places. Keyed by the `badgeKey` on entries in the feature
 * registry (src/config/features.js).
 */
export default function useFeatureBadges(role) {
    const [badges, setBadges] = useState({ pending: 0, brandstore: 0 });

    useEffect(() => {
        let cancelled = false;

        if (role === 'ADMIN' || role === 'CURATOR') {
            api.get('/products/pending')
                .then(r => {
                    if (!cancelled) {
                        setBadges(prev => ({ ...prev, pending: (r.data || []).length }));
                    }
                })
                // A failed count is not worth blocking the UI over, but swallowing it
                // silently shows "0 pending" when the truth is "we couldn't check".
                .catch(err => console.error('Failed to load pending-product count:', err));
        }

        if (role === 'ADMIN' || role === 'CURATOR') {
            api.get('/admin/brandstore/orders')
                .then(r => {
                    if (!cancelled) {
                        setBadges(prev => ({
                            ...prev,
                            brandstore: (r.data || []).filter(o => o.status === 'ORDER_RECEIVED').length,
                        }));
                    }
                })
                .catch(err => console.error('Failed to load Brandstore order count:', err));
        }

        return () => { cancelled = true; };
    }, [role]);

    return badges;
}
